import { FieldComponent } from "./chunk-GWGNVESG.js";
import { Datepicker_default } from "./chunk-3MRFZ3JL.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/DatepickerField/DatepickerField.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var SINGLE_DATEPICKER_FIELD_CLASSNAME_MAP = {};
var DatepickerField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      required,
      requiredLabel,
      description,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "required", "requiredLabel", "description", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */jsxs(FieldComponent, {
    id,
    name,
    label,
    required,
    requiredLabel,
    description,
    validation,
    validationMessage,
    className: clsx("pd:datepicker-field", className),
    children: [/* @__PURE__ */jsx(FieldComponent.Label, {
      className: "pd:datepicker-field__label"
    }), /* @__PURE__ */jsx(FieldComponent.Input, __spreadValues({
      ref,
      as: Datepicker_default,
      className: "pd:w-full"
    }, rest)), /* @__PURE__ */jsx(FieldComponent.ValidationMessage, {
      className: "pd:datepicker-field__validation-message"
    }), /* @__PURE__ */jsx(FieldComponent.Description, {
      className: "pd:datepicker-field__description"
    })]
  });
});
var DatepickerField_default = DatepickerField;
export { SINGLE_DATEPICKER_FIELD_CLASSNAME_MAP, DatepickerField_default };